var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42176 12.4774L1.42174 12.4774L0.630793 11.8026C0.496601 11.6881 0.496606 11.5339 0.630124 11.4195L6.00457 6.81272L6.36943 6.49998L6.00457 6.18725L0.630124 1.58054C0.630124 1.58054 0.630123 1.58054 0.630122 1.58054C0.496606 1.4661 0.496602 1.3119 0.630793 1.19742L1.42174 0.522633C1.5948 0.374986 1.89839 0.375005 2.07139 0.522618L2.07141 0.522633L8.85287 6.30815L8.85289 6.30817C8.98716 6.42271 8.98719 6.57726 8.85291 6.69185C8.8529 6.69185 8.85289 6.69186 8.85289 6.69186L2.07141 12.4774L2.32072 12.7696L2.07141 12.4774C1.89835 12.625 1.59476 12.625 1.42176 12.4774Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.823806
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.8cbba5a3c91b5bed3a14c16a0cf36051.svg";
export { ForwardRef as ReactComponent };